module.exports = __webpack_public_path__ + "static/media/element_dots_white.7aeeb809.svg";